import type { ReactNode } from "react";

interface GridProps {
  children: Readonly<ReactNode>;
}

export default function Grid({ children }: GridProps) {
  return (
    <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">{children}</div>
  );
}
